import { z } from 'zod'

/**
 * Schema para documento de identidad
 * Reutilizable en Client y Viatger
 * Codis oficials Mossos d'Esquadra (RD 933/2021)
 */
export const documentSchema = z.object({
  tipus_document: z.enum(['D', 'N', 'P', 'C', 'O']).default('D'),
  num_document: z.string().min(1, 'El número de document és obligatori'),
})

export type DocumentFormData = z.infer<typeof documentSchema>
